class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });

    // Add color update logic for cart items after content is loaded
    this.updateCartItemColors();
  }

  // Method to update item colors in the cart
  updateCartItemColors() {
    var cartItems = this.querySelectorAll('.cart-item');  // Select all cart items

    cartItems.forEach(function (item) {
      // Retrieve the variant ID of the item
      var variantId = item.getAttribute('data-variant-id');

      // Change background color based on the variant ID
      if (variantId === '46056867528842') {  // Purple variant
        item.style.backgroundColor = 'purple';
      } else if (variantId === '46056867561610') {  // Green variant
        item.style.backgroundColor = 'green';
      }
    });
  }

  // Rest of the code remains the same as you provided

  onCartUpdate() {
    // After cart update, refresh item colors
    this.updateCartItemColors();

    // Existing cart update logic continues...
  }

  // ... (rest of your CartItems class)
}

customElements.define('cart-items', CartItems);